import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiClient } from '../common/api-client.service';
import { SessionService, SessionData } from '../common/session.service';

class LoginModel {
  username: string;
  password: string;
}

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html'
})
export class LoginFormComponent {
  credentials = new LoginModel();

  constructor(
    private apiClient: ApiClient,
    private session: SessionService,
    private router: Router,
  ) {}

  login() {
    this.apiClient.post<SessionData>('/api/v1/login', this.credentials).toPromise().then(sess => {
      this.session.start(sess);
      this.router.navigateByUrl('/');
    }, res => {
      alert(res.error.errors);
    });
  }
}



// WEBPACK FOOTER //
// /srv/src/app/auth/login-form.component.ts